import { render, staticRenderFns } from "./AccreditationRequestDetails.view.vue?vue&type=template&id=81ad301e"
import script from "./AccreditationRequestDetails.view.vue?vue&type=script&lang=js"
export * from "./AccreditationRequestDetails.view.vue?vue&type=script&lang=js"
import style0 from "./AccreditationRequestDetails.view.vue?vue&type=style&index=0&id=81ad301e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports